// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingComponent_spinner__osVuK"};